import { ProveedorService } from 'src/app/services/proveedor.service';
import { Component, OnInit, ViewChild, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { SecurityService } from 'src/app/shared/services/security.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { v4 as uuidv4 } from 'uuid';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { QueryResult } from 'src/app/shared/object/queryResult.model';
import { ClienteProveedorService } from 'src/app/services/cliente-proveedor.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ToastService } from 'ng-uikit-pro-standard';


import * as _ from 'lodash'


enum QUERY_TYPE {
  ONLY_RUT = 'ONLY_RUT',
  VENDEDOR_CON_DEUDA = 'VENDEDOR_CON_DEUDA',
}

@Component({
  selector: 'app-modal-seleccionar-proveedor',
  templateUrl: './modal-seleccionar-proveedor.component.html',
  styleUrls: ['./modal-seleccionar-proveedor.component.scss'],
  providers: [SecurityService],
})
export class ModalSeleccionarProveedorComponent implements OnInit {

  // Output
  @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() onNotFound: EventEmitter<any> = new EventEmitter<any>();

  // Input
  @Input() origen: String = null
  @Input() showInfoProveedorInactivoBloqueado: boolean = false
  @Input() queryType: QUERY_TYPE = QUERY_TYPE.ONLY_RUT
  /** Con filtro solo proveedores en deuda, permite listar al proveedor sin saldo (p. ej. pagos cuenta corriente). */
  @Input() permitirVisualizarProveedorSinDeuda: boolean = false

  // Modales
  @ViewChild('seleccionarProveedor', { static: true }) seleccionarProveedorModal: ModalDirective;

  // Form
  formData: FormGroup

  // Data
  private rutEmpresa: number
  data: any = []
  paginationContext: PaginationContext = new PaginationContext()
  busquedaIniciada: boolean = false
  rutSearched: string = ''
  onlyRut: Boolean = false

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private clog: ConsoleService,
    private formValidatorsService: FormValidatorsService,
    private messageRendererService: MessageRendererService,
    private clienteProveedorService: ClienteProveedorService,
    private rutService: RutService,
    private proveedorDeudaService: ProveedorService,
    private toastService: ToastService
  ) {
    this.log = this.clog.log('MODAL-SELECCION-PROVEEDOR')
  }

  ngOnInit() {
    this.createForm()
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.paginationContext.RecordsByPage = 10

    this.formChangesSubscriptions()
  }

  formChangesSubscriptions() {
    this.formData.get("nombre").valueChanges.subscribe(nombre => {
      if(!nombre)
        return

      if(this.queryType === QUERY_TYPE.VENDEDOR_CON_DEUDA){
        this.buscarPorDeuda()
      }else{
        this.buscar()
      }
    })
  }

  /********* SHOW/HIDE *********/
  show() {
    this.cleanAll()
    this.seleccionarProveedorModal.show()
  }

  hide() {
    this.seleccionarProveedorModal.hide()
  }
  /********* SHOW/HIDE *********/

  /********* FORM *********/
  private createForm() {
    this.formData = this.fb.group({
      nombre: [''],
      rut: ['']
    });
  }

  private cleanFormData() {
    this.formData.reset()
    this.formData.markAsPristine()
    this.formData.markAsUntouched()
    this.initializeFormData()
  }

  private initializeFormData() {
    this.formData.get("nombre").setValue('')
    this.formData.get("rut").setValue('')
  }

  private cleanResultData() {
    this.busquedaIniciada = false
    this.data = []
  }

  private cleanAll() {
    this.cleanFormData()
    this.cleanResultData()
  }
  /********* FORM *********/

  /********* OPERATIONS *********/

  private createInputParams() {
    let rut = this.formData.get('rut').value
    rut = this.rutService.QuitarDV(rut)
    return {
      filtro: {
        exacto: { empresa_rut: this.rutEmpresa
          , rut
          , nombre: this.formData.get('nombre').value }
      },
      cantidadRegistrosPorPagina : 10, //this.paginationContext.CurrentPage,
      paginaActual: this.paginationContext.CurrentPage
    }
  }

  buscar(fromStartPage: Boolean = false) {
    if (fromStartPage) this.paginationContext.CurrentPage = 1

    // limpiar datos antes de desplegar
    this.cleanResultData()
    const inputParams = this.createInputParams()
    this.handleSearchByOrigin(inputParams)
  }

  private handleSearchByOrigin(inputParams) {
    // Query Local
    this.log(JSON.stringify(inputParams))
    this.clienteProveedorService.obtenerProveedoresSegunFiltro(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      this.paginationContext.RecordsCount = totalRegistros
      this.paginationContext.CurrentPage = paginaActual
      this.paginationContext.PagesCount = totalPaginas
      this.data = registros
      if (this.showInfoProveedorInactivoBloqueado) {
        const { nombre, rut } = this.formData.value
        if ((nombre === null || nombre.length === 0) && (rut !== null && rut.length > 0)) {
          this.verifyActivoBloquedAndShowMessage(rut)
        }
      }
      this.data.map(proveedor => {
        proveedor.rutFormato = this.rutService.AgregarDV(proveedor.rut)
        this.removeElementTypename(proveedor)
      })
      this.busquedaIniciada = true
      // this.loading = false
    })
  }

  private removeElementTypename(register: any) {
    delete register.__typename
    return register
  }

  onPageChange(context: PaginationContext) {
    this.paginationContext.CurrentPage = context.RequestedPage
    this.buscar()
  }

  // Se consume desde la vista
  selectData(proveedor: any) {
    proveedor.rutFormato = this.rutService.AgregarDV(proveedor.rut)
    const _proveedor = _.cloneDeep(proveedor)
    delete _proveedor.rutFormato
    delete _proveedor.__typename
    this.lastRut = this.rutService.AgregarDV(_proveedor.rut)
    this.onSelect.emit({
      data: _proveedor,
      origen: this.origen
    })
    this.log('seleccionó', _proveedor)
    this.hide()
  }

  private notFound() {
    this.onNotFound.emit()
  }

  lastRut: string = ''
  // Método para ser consumido desde fuera del componente
  searchByRut(rutConDv: string) {
    this.rutSearched = rutConDv
    if (!rutConDv || rutConDv.trim().length === 0)
      return

      rutConDv = rutConDv.trim()

    // this.log('input', rut, 'lastRut', this.lastRut, this.lastRut !== rut)
    if (this.lastRut !== rutConDv) {
      this.lastRut = rutConDv
      const rutSinDv = this.rutService.QuitarDV(this.rutService.Limpiar(rutConDv))

      if (this.permitirVisualizarProveedorSinDeuda && this.queryType === QUERY_TYPE.VENDEDOR_CON_DEUDA) {
        this.proveedorDeudaService.getProveedorConDeuda(this.rutEmpresa, rutSinDv, '', ({ mensajes, respuesta }) => {
          if (!respuesta) {
            if (this.showInfoProveedorInactivoBloqueado) {
              this.verifyActivoBloquedAndShowMessage(this.rutSearched)
            }
            this.notFound()
            return
          }
          const debtTotal = respuesta.totalRegistros != null ? respuesta.totalRegistros : 0
          const debtRegs = respuesta.registros || []
          if (debtTotal === 1 && debtRegs.length === 1) {
            this.removeElementTypename(debtRegs[0])
            this.selectData(debtRegs[0])
            return
          }
          if (debtTotal === 0) {
            const inputParams = {
              filtro: {
                exacto: { empresa_rut: this.rutEmpresa, rut: rutSinDv, nombre: '' }
              },
              cantidadRegistrosPorPagina: 10,
              paginaActual: 1
            }
            this.clienteProveedorService.obtenerProveedoresSegunFiltro(inputParams, ({ mensajes, respuesta: respProv }) => {
              if (!respProv || !respProv.registros || !respProv.registros.length || respProv.totalRegistros < 1) {
                if (this.showInfoProveedorInactivoBloqueado) {
                  this.verifyActivoBloquedAndShowMessage(this.rutSearched)
                }
                this.notFound()
                return
              }
              const proveedorSinDeuda =
                (respProv.registros || []).find((p) => p && p.condicion_pago_codigo != null && Number(p.condicion_pago_codigo) > 0) ||
                respProv.registros[0]
              proveedorSinDeuda.sinDeudaCuentaCorriente = true
              this.removeElementTypename(proveedorSinDeuda)
              this.selectData(proveedorSinDeuda)
            })
            return
          }
          this.abrirModalConProveedores(respuesta, false)
        })
        return
      }

      const inputParams = {
        filtro: {
          exacto: { empresa_rut: this.rutEmpresa
            , rut: rutSinDv
            , nombre: '' }
        },
        cantidadRegistrosPorPagina : 10, //this.paginationContext.CurrentPage,
        paginaActual: this.paginationContext.CurrentPage
      }
      this.clienteProveedorService.obtenerProveedoresSegunFiltro(inputParams, ({ mensajes, respuesta }) => {
        this.handleResultFromOutterSearch(respuesta)
      })
    }
  }

  /** Abre el modal con resultados ya paginados (lista de deuda o lista amplia). */
  private abrirModalConProveedores(respuesta: any, marcarSinDeuda: boolean) {
    const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
    if (marcarSinDeuda && registros && registros.length) {
      registros.forEach((p) => (p.sinDeudaCuentaCorriente = true))
    }
    this.formData.get('rut').setValue(this.rutSearched)
    this.paginationContext.RecordsCount = totalRegistros
    this.paginationContext.CurrentPage = paginaActual
    this.paginationContext.PagesCount = totalPaginas
    this.data = registros || []
    this.data.map((proveedor) => {
      proveedor.rutFormato = this.rutService.AgregarDV(proveedor.rut)
      this.removeElementTypename(proveedor)
    })
    if (this.showInfoProveedorInactivoBloqueado) {
      this.verifyActivoBloquedAndShowMessage(this.rutSearched)
    }
    this.busquedaIniciada = true
    this.seleccionarProveedorModal.show()
  }

  private handleResultFromOutterSearch(respuesta: { totalRegistros?: number; registros?: any[] }) {
    if (!respuesta) {
      if (this.showInfoProveedorInactivoBloqueado) {
        this.verifyActivoBloquedAndShowMessage(this.rutSearched)
      }
      this.notFound()
      return
    }
    const { totalRegistros, registros } = respuesta
    this.log('handleResultFromOutterSearch', { totalRegistros, registros })
    if (totalRegistros === 1) {
      this.removeElementTypename(registros[0])
      this.selectData(registros[0])
    } else {
      if (this.showInfoProveedorInactivoBloqueado) {
        this.verifyActivoBloquedAndShowMessage(this.rutSearched)
      }
      this.notFound()
    }
  }

  public clearLast() {
    this.lastRut = ''
  }
  /********* OPERATIONS *********/

  verifyActivoBloquedAndShowMessage(rutConDv: string) {
    let rut = this.rutService.Limpiar(rutConDv)
    rut = this.rutService.QuitarDV(rut)
    const inputParams = {
      entidad: {
        rut,
        empresa_rut: this.rutEmpresa
      }
    }

    this.clienteProveedorService.estadoProveedor(inputParams, ({ mensajes, respuesta }) => {
      const ok = mensajes === null && mensajes !== undefined && mensajes.length === 0
      if (!ok) {
        // this.messageRendererService.showInfoMessages(mensajes)
        this.messageRendererService.showErrors(mensajes)
        return
      }
    })
  }

  buscarPorDeuda(fromStartPage: Boolean = false) {
    if (fromStartPage) this.paginationContext.CurrentPage = 1

    // limpiar datos antes de desplegar
    this.cleanResultData()
    const inputParams = this.createInputParams()
    this.buscarProveedoresDeuda(inputParams)
  }


  buscarProveedoresDeuda(inputParams) {
    this.proveedorDeudaService.getProveedorConDeuda(inputParams.filtro.exacto.empresa_rut,
      inputParams.filtro.exacto.rut, inputParams.filtro.exacto.nombre,
      ({ mensajes, respuesta }) => {
      if (!respuesta) {
        this.data = []
        this.busquedaIniciada = true
        return
      }
      const totalReg = respuesta.totalRegistros != null ? respuesta.totalRegistros : 0
      let registros = respuesta.registros || []

      if (this.permitirVisualizarProveedorSinDeuda && this.queryType === QUERY_TYPE.VENDEDOR_CON_DEUDA && totalReg === 0) {
        this.clienteProveedorService.obtenerProveedoresSegunFiltro(inputParams, ({ mensajes, respuesta: respAmp }) => {
          if (!respAmp || !respAmp.registros || !respAmp.registros.length) {
            this.data = []
            this.busquedaIniciada = true
            return
          }
          const proveedorSinDeuda =
            (respAmp.registros || []).find((p) => p && p.condicion_pago_codigo != null && Number(p.condicion_pago_codigo) > 0) ||
            respAmp.registros[0]
          proveedorSinDeuda.sinDeudaCuentaCorriente = true
          this.removeElementTypename(proveedorSinDeuda)
          this.selectData(proveedorSinDeuda)
        })
        return
      }

      if (registros.count<0){
        this.toastService.warning("No se encontraron registros");
      }
      this.paginationContext.RecordsCount = respuesta.totalRegistros
      this.paginationContext.CurrentPage = respuesta.paginaActual
      this.paginationContext.PagesCount = respuesta.totalPaginas
      this.data = registros
      if (this.showInfoProveedorInactivoBloqueado) {
        const { nombre, rut } = this.formData.value
        if ((nombre === null || nombre.length === 0) && (rut !== null && rut.length > 0)) {
          this.verifyActivoBloquedAndShowMessage(rut)
        }
      }
      this.data.map(proveedor => {
        proveedor.rutFormato = this.rutService.AgregarDV(proveedor.rut)
        this.removeElementTypename(proveedor)
      })
      this.busquedaIniciada = true
    })
  }

}
